import { triggerBodyClass } from '../utils/dom/bodyClass';
import { toggleResizeEvent } from '../utils/dom/resize';
import { getMVKHouseById } from '../utils/mvk_data';
import { getFlatsInSectionFloor } from '../utils/parsers/flats';
import { getFloorsInSection } from '../utils/parsers/sections';
import { getURIWithoutHash } from '../utils/parsers/url';
export function toggleRouteUpdateAction(isInitial) {
  toggleResizeEvent();
  var queryString = window && window.history.state && window.history.state.uri ? getURIWithoutHash(window.history.state.uri.split('?').pop()) : undefined;
  return {
    isInitial: isInitial,
    queryString: queryString,
    type: 'IToggleRouteUpdateAction'
  };
}
export function setMVKPhaseAction(phase) {
  return {
    phase: phase,
    type: 'ISetMVKPhaseAction'
  };
}
export function setHoveredHouseIdAction(houseId) {
  return {
    houseId: houseId,
    type: 'ISetHoveredHouseIdAction'
  };
}
export function setHoveredSectionIdAction(sectionId, houseId, shouldIgnoreScroll) {
  return {
    houseId: houseId,
    sectionId: sectionId,
    shouldIgnoreScroll: shouldIgnoreScroll,
    type: 'ISetHoveredSectionIdAction'
  };
}
export function setHoveredFlatIdAction(flatId) {
  return {
    flatId: flatId,
    type: 'ISetHoveredFlatIdAction'
  };
}
export function toggleFullScreenAction(state) {
  toggleResizeEvent();
  triggerBodyClass('mvk_full_screen', state);
  return {
    state: state,
    type: 'IToggleFullScreenAction'
  };
}
export function changeFullScreenTipVisibilityAction(state) {
  return {
    state: state,
    type: 'IChangeFullScreenTipVisiblityAction'
  };
}
export function setHouseIdAction(houseId) {
  return function (dispatch, getState) {
    var _getState = getState(),
      MVKData = _getState.MVKData;
    dispatch({
      houseId: houseId,
      type: 'ISetHouseIdAction'
    });
    var selectedHouse = getMVKHouseById(MVKData, houseId);
    if (selectedHouse && selectedHouse.sections.length === 1) {
      dispatch(setSectionIdAction(selectedHouse.sections[0].id));
    }
  };
}
export function setSectionIdAction(sectionId) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      MVKData = _getState2.MVKData,
      house = _getState2.MVKState.house;
    dispatch({
      sectionId: sectionId,
      type: 'ISetSectionIdAction'
    });
    var floorsWithFlats = getFloorsInSection(MVKData, house.id, sectionId).filter(function (floor) {
      return getFlatsInSectionFloor(MVKData, house.id, sectionId, floor).length;
    });
    if (floorsWithFlats[0]) {
      dispatch(setFloorFilterAction(floorsWithFlats[0]));
    }
  };
}
export function setFlatIdAction(flatId) {
  return {
    flatId: flatId,
    type: 'ISetFlatIdAction'
  };
}
export function toggleFlatFilterAction(flatType) {
  return {
    flatType: flatType,
    type: 'IToggleFlatFilterAction'
  };
}
export function setFloorFilterAction(floor) {
  return {
    floor: floor,
    type: 'ISetFloorFilterAction'
  };
}